import { render, staticRenderFns } from "./whatsapp_settings.vue?vue&type=template&id=023c9486&scoped=true"
import script from "./whatsapp_settings.vue?vue&type=script&lang=js"
export * from "./whatsapp_settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023c9486",
  null
  
)

export default component.exports